import { Cpf } from 'models/domain/cpf.domain';
import { PhoneNumber } from 'models/domain/phoneNumber.domain';
import { Zipcode } from 'models/domain/zipcode.domain';
import * as yup from 'yup';

export const registerUserSchema = yup.object({
    fullname: yup.string()
        .required('Nome é obrigatório.')
        .min(3, 'Mínimo de 3 caracteres.')
        .max(70, 'Máximo de 70 caracteres.'),
    cpf: yup.string()
        .required('CPF é obrigatório.')
        .length(14, 'Preencha com o seu CPF.')
        .test('check cpf validity', 'CPF em formato inválido', (cpf) => {
            try {
                Cpf.fromString(cpf!);
                return true
            } catch (err) {
                return false;
            }
        }),
    birthDate: yup.date()
        .required('Data de nascimento é obrigatória.')
        .typeError('Data de nascimento inválida.')
        .max(new Date(), 'Não pode ser uma data maior do que hoje.')
        .min(new Date(1850, 0, 1), 'Você tem mais de 120 anos? 🤔'),
    phoneNumber: yup.string()
        .required('Número de telefone é obrigatório')
        .test('check phone number validity', 'Número de telefone inválido.', (number) => {
            try {
                PhoneNumber.fromString(number!);
                return true
            } catch (err) {
                return false;
            }
        }),
    email: yup.string()
        .required('E-mail é obrigatório')
        .email('E-mail inválido.'),
    cep: yup.string()
        .length(9, 'Preencha com o CEP de residência.')
        .test('check cep validity', 'CEP em formato inválido.', (cep) => {
            try {
                Zipcode.fromString(cep!);
                return true
            } catch (err) {
                return false;
            }
        })
        .optional(),
    streetName: yup.string()
        .required('Logradouro é obrigatório')
        .max(100, 'Máximo de 100 caracteres.'),
    streetType: yup.string()
        .required('Tipo de Logradouro é obrigatório')
        .max(100, 'Máximo de 100 caracteres.'),
    addressNumber: yup.string()
        .required('Número é obrigatório')
        .max(30, 'Máximo de 30 caracteres.'),
    addressComplement: yup.string()
        .max(100, 'Máximo de 100 caracteres.')
        .optional(),
    neighborhood: yup.string()
        .required('Bairro é obrigatório')
        .max(100, 'Máximo de 100 caracteres.'),
    city: yup.string()
        .required('Município é obrigatório')
        .max(100, 'Máximo de 100 caracteres.'),
    state: yup.string()
        .required('Estado é obrigatório')
        .max(100, 'Máximo de 100 caracteres.'),
    password: yup.string()
        .required('Senha é obrigatória.')
        .min(8, 'É obrigatório no mínimo 8 caracteres.')
        .matches(/[a-z]/g, 'Senha deve possuir 1 letra minúscula.')
        .matches(/[A-Z]/g, 'Senha deve possuir 1 letra maiúscula.')
        .matches(/\d/g, 'Senha deve possuir 1 dígito.'),
    confirmPassword: yup.string()
        .required('Confirmação de senha é obrigatória.')
        .min(8, { message: 'É obrigatório no mínimo 8 caracteres.' })
        .oneOf([yup.ref('password')], 'Senhas devem ser iguais')
});

export type RegisterUserFormData = {
    fullname: string;
    cpf: string;
    birthDate: Date;
    phoneNumber: string;
    email: string;
    cep: string;
    streetName: string;
    streetType: string;
    addressNumber: string;
    addressComplement?: string;
    neighborhood: string;
    city: string;
    state: string;
    password: string;
    confirmPassword: string;
}